/*
* props:
* stem:{}
* userAnswer: [[]]
* analysisAnswer
* choices: []
*
* */


import React ,{Component} from 'react';
import Material from 'components/Practice/Material';
import style from './question.css';
import AnswerAnalysis from 'components/Practice/Material/AnswerAnalysis.js';
export default class BlankQuestion extends Component{
  componentDidMount() {
    let blanks = this.stemList.refs.stem.getElementsByClassName('blank');
    let userAnswer = this.props.userAnswer;
    for(let i = 0 ,len=blanks.length;i<len;i++) {
      if(userAnswer[i].isCorrect) {
        blanks[i].className= 'blank correctText'
      }else {
        blanks[i].className= 'blank errorText'
      }
      blanks[i].value= userAnswer[i].answer;
      blanks[i].setAttribute('disabled',true);
    }
  }

  componentDidUpdate() {
    let blanks = this.stemList.refs.stem.getElementsByClassName('blank');
    let userAnswer = this.props.userAnswer;
    for(let i = 0 ,len=blanks.length;i<len;i++) {
      if(userAnswer[i].isCorrect) {
        blanks[i].className= 'blank correctText'
      }else {
        blanks[i].className= 'blank errorText'
      }
      blanks[i].value= userAnswer[i].answer;
      blanks[i].setAttribute('disabled',true);
    }
  }

  render() {
    const {question,analysisAnswer , userAnswer , choices , isSingleLayout , category} = this.props;
    return (
      <div>
        <Material
          stem={ question }
          ref={(c)=>{this.stemList=c;}}
          isSingleLayout={isSingleLayout}
          category={category}
          />
        <div className={style.answer}>
          <div className={style.answerShow}>
            <span>我的答案</span>
            <div>
              {
                userAnswer.map((item,index)=> {
                  return (
                    <div key={index} className={style.answerItem}>
                      <span>{item.questionIndex}. </span>
                    <span className={item.isCorrect ? style.correctText : style.myAnswerText}>
                      {item.answer || '-'}
                    </span>
                    </div>
                  )
                })
              }
            </div>
          </div>
          <div className={style.answerShow}>
            <span>正确答案</span>
            <div>
              {
                choices.map((item,index)=> {
                  return (
                    <div key={index} className={style.answerItem}>{`${item.question_index}. ${item.content[0]}`}</div>
                  )
                })
              }
            </div>
          </div>
        </div>
        <AnswerAnalysis analysisAnswer={ analysisAnswer } />
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Answer/Question/BlankQuestion.js
 **/